/* eslint-disable react/prop-types */
import { Dropdown } from 'react-bootstrap';
import Icon from 'components/icon';
import classNames from 'classnames';

const RenderAction = ({
  action,
  defaultLabel,
  defaultIcon,
  className,
  eventKey
}) => {
  if (action) {
    return (
      <Dropdown.Item
        className={classNames(className, action.className)}
        style={{ opacity: action.disabled ? '0.3' : '1' }}
        eventKey={eventKey}
        onClick={action.action}
        disabled={action.disabled}
      >
        <Icon
          icon={action.icon ?? defaultIcon}
          className={action.iconClassName}
          fontSize={action.fontSize ?? '14px'}
        />{' '}
        {action.label ?? defaultLabel}
      </Dropdown.Item>
    );
  }
  return null;
};

export default RenderAction;
